import { TipoConteudoAgendado } from '@domain/conteudos-agendados'
import { ScheduledContentType } from '../remote-types/scheduled-content'
import { typeAdapter } from '@services/utils/type-adapter'

export const ScheduledContentTypeAdapter = typeAdapter(
  TipoConteudoAgendado,
  ScheduledContentType,
  'Tipo de conteúdo agendado'
)
